<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <owner-address
                [isSwisslifeProduct]="isSwisslifeProduct"
              ></owner-address>
              <div class="address-form__separator"></div>
              <checkbox-container>
                <pr-input-checkbox
                  [derrors]="derrors"
                  formControlName="fiscalAddressIsNotContactAddress"
                  label="Mon adresse fiscale est différente de mon adresse de correspondance"
                >
                </pr-input-checkbox>
              </checkbox-container>
              @if (
                owner.get('fiscalAddressIsNotContactAddress')?.value == true ||
                owner.get('fiscalAddressIsNotContactAddress')?.value !=
                  undefined
              ) {
                <fiscal-address
                  [isSwisslifeProduct]="isSwisslifeProduct"
                  [derrors]="derrors"
                ></fiscal-address>
              }
            </div>
          </ng-container>
        }
      </div>
    </ng-container>

    @if (isEuodiaVieProduct) {
      <info [option]="{ icon: 'info' }"
        >Le contrat Euodia Vie n’est pas éligible pour les non résidents fiscaux
        français.</info
      >
    }
  </form-wrapper>
  <form-footer
    (prev)="prev()"
    (next)="onSubmit()"
    [disabledSkip]="true"
  ></form-footer>
</form>
